export const navigateToLessonsPlan = (baseUrl) => {
  const updatedUrl = baseUrl?.substring(0, baseUrl?.lastIndexOf("/"));
  window.location.href = `${updatedUrl}/`;
};
